<template>
  <div class="vehicle-info">
    <ucar-title to="/progress-info">{{title}}</ucar-title>
    <div class="vehicle-info-fail-wrapper" v-if="vuexVehicleInfo && vuexVehicleInfo.failReason">
      <p class="vehicle-info-fail-header">驳回原因</p>
      <p class="vehicle-info-fail-content">{{vuexVehicleInfo.failReason}}</p>
    </div>
    <div class="photo-info">
      <div class="photo-group-title">行驶证</div>
      <div class="photo-group">
        <ucar-upload-img
          v-bind="photoBaseData.carLicense"
          v-model="photoInfo.vehicleLicenseImgUrl"
          @uploadFinish="autoInputVehicleLicense"
          :error="photoError.carLicense"
        ></ucar-upload-img>
        <ucar-upload-img
          v-bind="photoBaseData.carSecondLicense"
          v-model="photoInfo.vehicleLicenseCopyImgUrl"
        ></ucar-upload-img>
      </div>
      <div class="photo-group-title">车辆</div>
      <div class="photo-group">
        <ucar-upload-img
          v-bind="photoBaseData.car"
          v-model="photoInfo.vehicleUrl"
        ></ucar-upload-img>
        <ucar-upload-img
          v-bind="photoBaseData.carVin"
          v-model="photoInfo.vehicleFrameUrl"
        ></ucar-upload-img>
      </div>
      <template v-if="this.info.haveNetworkLicense === 1">
        <div class="photo-group-title">网络预约出租汽车运输证</div>
        <div class="photo-group">
          <ucar-upload-img
            v-bind="photoBaseData.networkCarTransportLiscense"
            v-model="photoInfo.onLineVehicleLicenseUrl"
          ></ucar-upload-img>
        </div>
      </template>
    </div>
    <ucar-section title="以下为自动识别图片的结果，如不正确请修改" v-if="ocrComplete">
      <div class="row row-info">
        <label>车牌号</label>
        <ucar-select
          class="car-info-region"
          :options="baseData.licencePlates"
          placeholder
          v-model="info.region"
        ></ucar-select>
        <input placeholder="请输入" v-model="info.licenceNum" maxlength="7" class="licenceNum">
      </div>
      <div class="row row-info">
        <label>车辆所有人</label>
        <dynamic-textarea v-model="info.vehicleLicenseOwner" :maxlength="30" placeholder="请输入"></dynamic-textarea>
      </div>
      <div class="row row-info">
        <label>车辆注册日期</label>
        <ucar-date-select
          v-model="info.vehicleLicenseRegisterDate"
          :start-date="new Date((new Date()).getFullYear() - 10, (new Date()).getMonth(), (new Date()).getDate())"
          :end-date="new Date()"
          ></ucar-date-select>
      </div>
      <div class="row row-info">
        <label>车辆识别号</label>
        <input placeholder="请输入" v-model="info.vehicleLicenseVin" maxlength="17">
      </div>
    </ucar-section>
    <ucar-section>
      <div class="row" v-if="needNetworkCarLicense !== 1">
        <label class="lang">是否有网约车运输证</label>
        <ucar-select
          :options="networkLicenseOptions"
          placeholder="请选择"
          :disabled="needNetworkCarLicense === 1"
          v-model="info.haveNetworkLicense"
        ></ucar-select>
      </div>
      <template v-if="this.info.haveNetworkLicense === 1">
        <div class="row">
          <label class="middle">网约车运输证证件号</label>
          <dynamic-textarea v-model="info.onLineVehicleLicenseNo" :maxlength="40" placeholder="请输入"></dynamic-textarea>
        </div>
        <div class="row">
          <label>运输证有效期</label>
          <ucar-date-select v-model="info.onLineVehicleLicenseValidDate"
            :start-date="new Date()"
            :end-date="new Date((new Date()).getFullYear() + 20, (new Date()).getMonth(), (new Date()).getDate())"
            ></ucar-date-select>
        </div>
      </template>
      <div class="row">
        <label>车型</label>
        <ucar-car-select placeholder="请选择" v-model="info.carModel"></ucar-car-select>
      </div>
      <div class="row">
        <label>年检到期日</label>
        <ucar-date-select
          v-model="info.vehicleLicenseAnnualInspectionDate"
          :start-date="new Date()"
          :end-date="new Date((new Date()).getFullYear() + 10, (new Date()).getMonth(), (new Date()).getDate())"
        ></ucar-date-select>
      </div>
    </ucar-section>
    <!-- <ucar-section title="以下为自动识别图片的结果，如不正确请修改" v-if="rejectedCount >= 3">
      <div class="row">
        <label>车牌号</label>
        <ucar-select
          class="car-info-region"
          :options="baseData.licencePlates"
          placeholder
          v-model="info.region"
        ></ucar-select>
        <input placeholder="请输入" v-model="info.licenceNum" maxlength="7">
      </div>
      <div class="row">
        <label>车辆所有人</label>
        <dynamic-textarea v-model="info.vehicleLicenseOwner" :maxlength="30" placeholder="请输入"></dynamic-textarea>
      </div>
      <div class="row">
        <label>车辆注册日期</label>
        <ucar-date-select
          v-model="info.vehicleLicenseRegisterDate"
          :start-date="new Date((new Date()).getFullYear() - 10, (new Date()).getMonth(), (new Date()).getDate())"
          :end-date="new Date()"
          ></ucar-date-select>
      </div>
      <div class="row">
        <label>车辆识别号</label>
        <input placeholder="请输入" v-model="info.vehicleLicenseVin" maxlength="17">
      </div>
    </ucar-section> -->

    <div class="footer">
      <button type="button" class="btn-submit" :class="{'btn-submit-enable': enableSubmit}" @click="submit">提交</button>
    </div>
    <error-dialog v-if="showErrorDialog" @close="closeErrorDialog" :groups="rejectErrors"></error-dialog>
    <vehicle-tips v-if="showTips" :list="vuexCurrentCity.carRequire" @hide="showTips = false"></vehicle-tips>
  </div>
</template>

<style lang="stylus">
@import '../../styles/variable.styl'

.vehicle-info-fail-wrapper {
  margin-bottom: 20px;
  background-color: #fff;
  margin-bottom: 20px;
  padding: 30px;
  .vehicle-info-fail-header {
    font-size: $ucar_font_h4;
    line-height: 1;
    margin-bottom: 20px;
  }
  .vehicle-info-fail-content {
    color: $ucar_label_color;
    font-size: $ucar_font_h5;
    line-height: 1.5;
  }

}
.vehicle-info .row .licenceNum{
    width:60px;
  }
</style>

<script>
import carSelect from '../../components/car-select'
import VehicleTips from '../../components/vehicle-tips'
import DynamicTextarea from '../../components/dynamic-textarea'
import ErrorDialog from '../../components/error-dialog'
import UcarDate from 'ucar-date'
import valid from '../../utils/valid-check'
import preload from '../../utils/preload'
import { copyTargetProperty, compareTargetProperty } from '../../utils/transform'
import { PhotoBaseData, licencePlates, resetVehicleLicense } from '../../utils/constants'
import { validateVehicleInfo, readVehicleLicense, submitVehicleInfo } from '../../api'
export default {
  data () {
    return {
      rejectedCount: 0,
      showTips: false,
      showRejectInfo: false,
      showErrorDialog: false,
      rejectErrors: [],
      vehicleLicenseOcrInfo: {
        ...resetVehicleLicense
      },
      info: {
        vehicleLicenseOwner: '', // 车辆所有人
        vehicleLicenseVehicleType: '', // 行驶证车辆类型
        region: '京',
        vehicleLicenseRegisterDate: '', // 车辆注册日期
        vehicleLicenseAddress: '', // 行驶证地址
        vehicleLicenseUseCharacter: '', // 车辆使用性质
        vehicleLicenseIssueDate: '', // 行驶证发证日期
        vehicleLicensePlateNo: '',
        vehicleLicenseOcr: 1,
        licenceNum: '',
        carModel: '',
        vehicleLicenseVin: '',
        vehicleLicenseEngineNo: '', // 车辆发动机号
        haveNetworkLicense: '',
        onLineVehicleLicenseNo: '', // 网约车运输证号
        onLineVehicleLicenseValidDate: (new UcarDate()).dateStr, // 网约车运输证有效期
        vehicleLicenseAnnualInspectionDate: ''
      },
      photoInfo: {
        vehicleLicenseImgUrl: '',
        vehicleLicenseCopyImgUrl: '',
        vehicleUrl: '',
        vehicleFrameUrl: '',
        onLineVehicleLicenseUrl: ''
      },
      photoError: {
        carLicense: ''
      },
      photoBaseData: PhotoBaseData,
      baseData: {
        licencePlates: licencePlates
      }
    }
  },
  computed: {
    ocrComplete(){
      return this.info.licenceNum || this.info.vehicleLicenseOwner || this.info.vehicleLicenseVin
    },
    needNetworkCarLicense() {
      return this.vuexCompanyId ? this.vuexCurrentCity.needCompanyNetworkCarLicense : this.vuexCurrentCity.needNetworkCarLicense
    },
    networkLicenseOptions () {
      return this.needNetworkCarLicense === 1 ? [{name: '是', value: 1}] : [
        {
          name: '是',
          value: 1
        },
        {
          name: '否',
          value: 0
        }
      ]
    },
    enableSubmit () {
      const errorInfo =
        valid.notEmpty(this.info.vehicleLicenseOwner, '车辆所有人姓名') ||
        valid.notEmpty(this.photoInfo.vehicleLicenseImgUrl, '行驶证正本') ||
        valid.notEmpty(this.photoInfo.vehicleLicenseCopyImgUrl, '行驶证副本') ||
        valid.notEmpty(this.photoInfo.vehicleUrl, '全车照片') ||
        valid.notEmpty(this.photoInfo.vehicleFrameUrl, '车架号照片') ||
        (this.info.haveNetworkLicense === 1 &&
        valid.notEmpty(this.photoInfo.onLineVehicleLicenseUrl, '网约车运输证')) ||
        (this.info.haveNetworkLicense === 1 &&
        valid.notEmpty(this.info.onLineVehicleLicenseNo, '网约车运输证证件号')) ||
        (this.info.haveNetworkLicense === 1 &&
        valid.notEmpty(this.info.onLineVehicleLicenseValidDate, '运输证有效期')) ||
        valid.notEmpty(this.info.vehicleLicenseRegisterDate, '车辆注册日期') ||
        valid.notEmpty(this.info.vehicleLicenseVin, '车辆识别号') ||
        valid.notEmpty(this.info.vehicleLicenseAnnualInspectionDate, '年检到期日') ||
        valid.notEmpty(this.info.carModel, '车型') ||
        valid.notEmpty(this.info.licenceNum, '车牌号')
      return errorInfo === ''
    }
  },
  components: {
    'ucar-car-select': carSelect,
    ErrorDialog,
    DynamicTextarea,
    VehicleTips
  },
  methods: {
    getBaseData () {
      this.$loading.show()
      preload([
        PhotoBaseData.carLicense.defaultImg,
        PhotoBaseData.carSecondLicense.defaultImg,
        PhotoBaseData.car.defaultImg,
        PhotoBaseData.carVin.defaultImg,
        PhotoBaseData.networkCarLicense.defaultImg
      ]).then(() => {
        if (this.vuexVehicleInfo) {
          copyTargetProperty(this.info, this.vuexVehicleInfo)
          copyTargetProperty(this.photoInfo, this.vuexVehicleInfo)
          this.rejectedCount = this.vuexVehicleInfo.vehicleRejectedCount
          const region = this.baseData.licencePlates.find(item => item.name === this.vuexVehicleInfo.vehicleLicensePlateNo[0])
          this.info.region = region.value || ''
          this.info.licenceNum = this.vuexVehicleInfo.vehicleLicensePlateNo.substr(1, this.vuexVehicleInfo.vehicleLicensePlateNo.length - 1)
          // 如果是从缓存中读取，需要对当前缓存中的信息做判断如果上次提交的OCR识别结果为完成，则需将当前缓存的提交信息反向映射为OCR行驶证缓存信息，以便在提交时完成对比
          if (this.vuexVehicleInfo.vehicleLicenseOcr === 1) copyTargetProperty(this.vehicleLicenseOcrInfo, this.info)
        }
        this.info.haveNetworkLicense = this.needNetworkCarLicense === 1 ? 1 : 0
        this.$loading.hidden()
      })
    },
    async autoInputVehicleLicense (val) {
      this.$loading.show('正在识别图片信息')
      try {
        this.trackEvent('司招-行驶证正面上传', 'success')
        const res = await readVehicleLicense({
          recruitId: this.vuexRecruitId,
          vehicleLicenseImgUrl: val
        })
        this.$loading.hidden()
        this.info = {...this.info, ...res}
        if (res.vehicleLicensePlateNo) {
          const region = this.baseData.licencePlates.find(item => item.name === res.vehicleLicensePlateNo[0])
          this.info.region = region.value || ''
          this.info.licenceNum = res.vehicleLicensePlateNo.substr(1, res.vehicleLicensePlateNo.length - 1)
        }
        // 缓存识别成功的行驶证OCR信息
        copyTargetProperty(this.vehicleLicenseOcrInfo, this.info)
        this.$alert({
          type: 'success',
          content: '识别图片成功'
        })
        // 去除OCR识别错误提示
        this.photoError.carLicense = ''
      } catch (error) {
        // 识别失败，重置行驶证信息
        this.info = {...this.info, ...resetVehicleLicense}
        // 重置缓存中的行驶证OCR信息
        copyTargetProperty(this.vehicleLicenseOcrInfo, this.info)
        this.photoError.carLicense = '未识别到行驶证正面信息，请重新上传'
        this.trackEvent('司招-行驶证正面识别失败', 'error')
      }
    },
    async submit () {
      try {
        const errorInfo =
          valid.cnName(this.info.vehicleLicenseOwner, '请输入正确的车辆所有人名称') ||
          valid.carOwnerLimit(this.info.vehicleLicenseOwner) ||
          valid.carNumber(this.info.licenceNum)
          console.log(errorInfo)
        if (errorInfo) {
          this.$alert(errorInfo)
          return
        }
        const body = {
          ...this.info,
          ...this.photoInfo,
          vehicleLicensePlateNo: `${this.info.region}${this.info.licenceNum}`,
          brand: this.info.carModel.currentBrand.carIdent,
          modelId: Number(this.info.carModel.currentModel.id),
          colorId: Number(this.info.carModel.currentColor.id),
          recruitId: this.vuexRecruitId,
        }
        // 如果行驶证相关信息与缓存中的行驶证OCR信息不符则证明用户手动修改过行驶证相关信息
        body.vehicleLicenseOcr = compareTargetProperty(this.vehicleLicenseOcrInfo, body) ? 1 : 0
        delete body.carModel
        this.trackEvent('司招-申请表单车-提交', 'click')
        // 后端校验车辆信息
        await validateVehicleInfo(body)
        const submitRes = await submitVehicleInfo(body)
        if (submitRes.checkResult === 1) {
          this.$router.push(`/progress-info?id=${this.vuexRecruitId}`)
          return
        }
        // 处理驳回错误信息
        if (submitRes.checkResult === 2) {
          this.rejectedCount = submitRes.rejectedCount
          if (submitRes.vehicleLicenseCheckList.length > 0) {
            const group = {
              title: '行驶证',
              type: 'list',
              list: []
            }
            const list = submitRes.vehicleLicenseCheckList
            list.forEach(item => {
              group.list.push(item)
            })
            this.rejectErrors.push(group)
          }
          if (submitRes.otherCheckList.length > 0) {
            const group = {
              title: '其他',
              type: 'text',
              content: ''
            }
            const list = submitRes.otherCheckList
            list.forEach(item => {
              group.content += `${item.field}:${item.desc};`
            })
            this.rejectErrors.push(group)
          }
          this.showErrorDialog = true
          return
        }
        if (submitRes.checkResult === 3) {
          this.$router.push(`/progress-info?id=${this.vuexRecruitId}`)
        }
      } catch (error) {
        console.warn(error)
      }
    },
    closeErrorDialog () {
      this.showErrorDialog = false
      this.rejectErrors = []
    }
  },
  mounted () {
    if (this.$route.query.showTips === '1') this.showTips = true
    this.getBaseData()
  }
}
</script>
